<template>
  <router-view />
</template>

<script>
export default {
  name: 'GuestsIndex',
}
</script>
